<template>
  <div class="product_list_box">
    <div class="nav">
        <span style="color: #808080">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/productHome' }"
            >产品选型</el-breadcrumb-item
          >
          <el-breadcrumb-item >规格列表</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
    <div class="box1">
      <Level :list="typeList" @levelChange="levelChange" :activeClass="xx_query.platformTypeCode" />
    </div>
    <div class="box2">
      <div class="flex-center">
        <span class="name">品牌</span>
        <span>：</span>
      </div>
      <div class="content">
        <div
          :class="
            xx_query.brand == item.name || activeBrand == item.name
              ? ' item activeItem '
              : 'item'
          "
          @mouseenter="activeBrand = item.name"
          @mouseleave="activeBrand = ''"
          v-for="(item, index) in brandList"
          :key="index"
          @click="handleBrand(item.uuid, item.name)"
          class="ellipsis-1"
        >
          <span
            v-if="xx_query.brand == item.name || activeBrand == item.name"
            class="name"
            >{{ item.name }}</span
          >
          <img v-else :src="item.img" />
        </div>
      </div>
    </div>
    <div class="box3">
      <div class="flex-center">
        <span class="name">参数</span>
        <span>：</span>
      </div>
      <div class="content">
        <div
          class="item"
          v-for="(item, index) in paramsList.filter((ele, ind) => {
            return ind < 4;
          })"
          :key="index"
        >
          <div v-if="item.type == 'INPUT'">
            <span class="name">{{ item.name }}</span>
            <el-input v-model="item.value" size="small">
              <template slot="suffix" v-if="item.unit">{{
                item.unit
              }}</template>
            </el-input>
          </div>
          <div v-if="item.type == 'SELECT'">
            <span class="name">{{ item.name }}</span>
            <el-select v-model="item.value" size="small">
              <el-option
                v-for="optionsItem in item.options"
                :key="optionsItem.value"
                :label="optionsItem.value"
                :value="optionsItem.value"
              >
              </el-option>
            </el-select>
          </div>
          <div v-if="item.type == 'RADIO'">
            <span class="name">{{ item.name }}</span>
            <el-radio-group v-model="item.value" size="small">
              <el-radio
                v-for="(optionsItem, index) in item.options"
                :key="index"
                :label="optionsItem.value"
                >{{ optionsItem.value }}</el-radio
              >
            </el-radio-group>
          </div>
          <div v-if="item.type == 'CHECKBOX'">
            <span class="name">{{ item.name }}</span>
            <el-checkbox-group v-model="item.value" size="small">
              <el-checkbox
                v-for="(optionsItem, index) in item.options"
                :key="index"
                :label="optionsItem.value"
                >{{ optionsItem.value }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div v-if="item.type == 'DATE'">
            <span class="name">{{ item.name }}</span>
            <el-date-picker
              type="date"
              size="small"
              placeholder="选择日期"
              v-model="item.value"
            ></el-date-picker>
          </div>
        </div>
        <span class="more_bt" @click="moreMessage" :class="paramsListShow? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></span>
        <el-button type="primary" @click="searchXX" class="parmas_btn">确认</el-button>
         <el-button @click="paramsReset" class="parmas_btn">重置</el-button>
          <div v-if="paramsListShow">
            <Parameter
              :paramsList="
                paramsList.filter((ele, ind) => {
                  return ind > 3;
                })
              "
              @parameterChange="parameterChange"
              :rightNum="'9%'"
              :nameWith="'0 0 26px'"
            />
          </div>
        <!-- </el-popover> -->
      </div>
    </div>
    <div class="box3_two">
      <div class="flex-center">
        <span class="name">搜索</span>
        <span>：</span>
      </div>
      <el-input
          v-model="xx_query.name"
          class="xx_input"
          suffix-icon="el-icon-search"
          placeholder="请输入规格名称"
          @change="handleInputMesg"
      >
      </el-input>
    </div>
    <div class="box4">
      <!-- <div :class="xx_query.szm == '' ? 'item1 activeItem' : 'item1'">
        <span>全部</span>
      </div> -->
      <div
        :class="szm == item ? 'item activeItem' : 'item'"
        v-for="(item, index) in letterList"
        :key="index"
        @click="handleSZM(item)"
      >
        <span>{{ item }}</span>
      </div>
    </div>
    <div class="box5">
      <Spec :productList="productList" />
      <el-empty description="暂无产品" v-if="productList.length == 0"></el-empty>
      <el-pagination
        style="text-align: center; margin-bottom: 20px"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="xx_query.pageSize"
        :current-page="xx_query.current"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Level from "./components/Level.vue";
import Parameter from "../parameter/Parameter.vue";
import {
  getAllProductBrandList,
  getProductParams,
  getProductSpecList,
  productTypetree
} from "../../utils/product";
import Spec from "./components/Spec";
export default {
  components: {
    Spec,
    Level,
    Parameter,
  },
  data() {
    return {
      szm: "全部",
      xx_query: {
        params: [],
        platformTypeCode: "",
        brandUuid: "",
        chinesePinYin : "",
        current: 1,
        pageSize: 12,
      },
      cs: [],
      typeList: [],
      brandList: [],
      paramsList: [],
      moreList: [],
      letterList: [...Array(26).keys()].map((i) => String.fromCharCode(i + 65)),
      productList: [],
      activeBrand: "",
      total: 0,
      paramsListShow: false
    };
  },
  created() {
    let params = this.$route.query.params
    if(params) {
      Object.assign(this.xx_query,JSON.parse(params));
      if(this.enLetter(this.xx_query.chinesePinYin)){
        this.szm = this.xx_query.chinesePinYin.toLocaleUpperCase()
      }
    }
    this.letterList.unshift("全部");
    this.platformTypetree();
    this.platformBrandList()
    this.platProductParams()
    this.getProductList()
    // this.getParamsList();
    console.log('paramsList', this.paramsList)
  },
  methods: {
    moreMessage() {
      this.paramsListShow = !this.paramsListShow;
    },
    handleInputMesg() {
      this.getProductList();
    },
    // 判断是否为字母
    enLetter(val) {
      let isletter = /^[a-zA-Z]+$/.test(val);
      return isletter
    },
    platformTypetree() {
      let params = {
        grade: "2",
        type: 'PLATFORM'
      }
      productTypetree(params).then((res) => {
        if(res) {
          this.typeList = res;
          this.typeList.map(item => {
            if(item.children) {
              item.children.unshift(
                {
                    code :  "",
                    label: "全部",
                }
              )
            }
          })
          this.typeList.unshift(
              {
                  code :  "",
                  label: "全部",
              }
          )
        }
      });
    },
    platformBrandList() {
      getAllProductBrandList({auditStatus: 'PASS', interfaceType: 'admin'}).then((res) => {
        if(res) {
          this.brandList = res.map(obj => Object.assign({}, obj, {img: obj.image}));
          console.log('brandList', this.brandList)
        }
      })
    },
    handleHome() {
      this.$router.push("/productHome");
    },
    //分类改变
    levelChange(info) {
      let platformTypeCode = Object.values(info).sort(function(a, b) { return b.length - a.length; })[0];
      this.xx_query.platformTypeCode = platformTypeCode?platformTypeCode:''
      console.log("分类改变", this.xx_query);
      this.getProductList()
    },
    //品牌改变
    handleBrand(uuid, name) {
      if (this.xx_query.brandUuid == uuid) {
        this.xx_query.brandUuid = "";
        this.xx_query.brand = ""
        this.activeBrand = ""
      } else {
        this.xx_query.brandUuid = uuid;
        this.xx_query.brand = name
        this.activeBrand = name
      }
      console.log("分类改变", this.xx_query);
      this.getProductList()
    },
    platProductParams() {
      getProductParams({
        origin:'PLATFORM'
      }).then(result=>{
        this.paramsList = result.filter(item => item.isSearch)
            .map((m) => {
                return {
                  ...m,
                  value: m.type == "CHECKBOX" ? [] : "",
                };
            });
      this.xx_query.params.map(item => {
        this.paramsList.map(items => {
          if(item.uuid == items.uuid) {
            items.value = item.value
          }
        })
      })
        // this.getParamsList();
      })
    },
    //首字母改变
    handleSZM(value) {
      this.szm = value
      if(value == '全部') {
        this.xx_query.chinesePinYin = "";
        // if (this.xx_query.szm == value) {
        //   this.xx_query.chinesePinYin = "";
        // } else {
        //   this.xx_query.chinesePinYin = value.toLowerCase();
        // }
      } else {
        this.xx_query.chinesePinYin = value.toLowerCase()
      }
      this.getProductList();
    },
    //参数列表
    getParamsList() {
      this.paramsList = this.paramsList.map((m) => {
        return {
          ...m,
          value: m.type == "CHECKBOX" ? [] : "",
        };
      });
    },
    //参数改变
    parameterChange(info) {
      // console.log("更多改变", info);
      this.moreList = info;
    },
    //参数重置
    paramsReset(){
        this.paramsList = this.paramsList.map((m) => {
          return {
            ...m,
            value: m.type == "CHECKBOX" ? [] : "",
          };
        });
        this.moreList = this.moreList.map((m) => {
          return {
            ...m,
            value: m.type == "CHECKBOX" ? [] : "",
          };
        });
        this.cs = [];
        this.searchXX()
    },
    //选型
    searchXX() {
      let list = this.paramsList
        .filter((ele, ind) => {
          return ind < 3;
        })
        .concat(this.moreList);
      console.log("resList", list)
      this.cs = list.map((m) => {
        if(m.type === 'CHECKBOX') {
          return {
            name: m.name,
            value: m.value.length?m.value.join(','):'',
            uuid: m.uuid,
          }
        } else {
          return {
            name: m.name,
            value: m.value,
            uuid: m.uuid,
          };
        }
      });
      // let param = {params: this.cs}
      this.xx_query.params = this.cs
      console.log(this.xx_query);
      this.getProductList()
    },
    getProductList() {
      let params = this.xx_query
      params.params =  params.params.filter(m=>m.value!=='')
      getProductSpecList(this.xx_query).then((res) => {
        if(res) {
          this.total = res.total;
          this.productList = res.list;
        }
      })
    },
    currentChange(value) {
      this.xx_query.current = value;
      this.getProductList()
    },
  },
};
</script>

<style lang="less" scoped>
@import "./style/index";
/deep/ .el-input__suffix {
  display: flex;
  align-items: center;
}
/deep/ .el-popover {
  left: 0;
  padding: 10px !important;
}
.ellipsis-1 {
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.flex-center {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.product_list_box {
  width: 1200px;
  margin: 0 auto;
  color: #333333;
  font-size: 14px;
  .breadcrumb {
    margin: 20px 0;
    .home {
      cursor: pointer;
    }
    .line {
      margin: 0 5px;
    }
  }
  .box2 {
    padding: 10px;
    border: 1px solid #ddd;
    display: flex;
    align-items: center;
    border-top: none;
    .name {
      flex: 0 0 58px;
      width: 58px;
      text-align: justify;
      text-align-last: justify;
      text-justify: distribute-all-lines;
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      .item {
        cursor: pointer;
        margin-right: 10px;
        img {
          width: 110px;
          height: 52px;
          object-fit: fill;
        }
      }
      .activeItem {
        border: 1px solid #009999;
        color: #009999;
        text-align: center;
        line-height: 52px;
        height: 50px;
        width: 108px;
      }
    }
  }
  .box3 {
    padding: 9px 10px;
    border: 1px solid #ddd;
    display: flex;
    border-top: none;
    align-items: baseline;
    position: relative;
    .name {
      flex: 0 0 58px;
      width: 58px;
      padding: 5px 0;
      text-align: justify;
      text-align-last: justify;
      text-justify: distribute-all-lines;
    }
    .content {
      .item {
        display: inline-block;
        margin-right: 10px;
        width: 19%;
        div {
          display: flex;
          align-items: center;
          .name {
            flex: 0 0 26px;
            color: #000;
            font-size: 14px;
            display: inline-block;
            margin-right: 5px;
            white-space: nowrap;
            text-align-last: auto;
            flex-shrink: 0;
            text-align: right;
          }
        }
      }
      .more_bt {
        color: #2d50a1;
        font-size: 16px;
        margin: 0 10px;
        cursor: pointer;
      }
      .parmas_btn {
        height: 34px;
        line-height: 2px;
      }
    }
  }
  .box3_two {
    padding: 10px;
    border: 1px solid #ddd;
    display: flex;
    border-top: none;
    align-items: center;
    position: relative;
    .name {
      flex: 0 0 58px;
      width: 58px;
      padding: 5px 0;
      text-align: justify;
      text-align-last: justify;
      text-justify: distribute-all-lines;
    }
    .xx_input {
      width: 400px;
      height: 32px;
      /deep/.el-input__inner {
        height: 32px;
      }
    }
  }
  .box4 {
    display: flex;
    justify-content: space-between;
    background: #cbcbcb;
    color: #333333;
    font-size: 16px;
    margin: 20px 0;
    .item1 {
      width: fit-content;
      padding: 0 5px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
    }
    .item1:hover {
      background: #009999;
      color: #fff;
    }
    .item {
      min-width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      padding: 0 5px;
    }
    .item:hover {
      background: #009999;
      color: #fff;
    }
    .activeItem {
      background: #009999;
      color: #fff;
      padding: 0 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/specList.vue